export default __webpack_public_path__ + "static/media/paymentLogo.b5c45dfd.png";